import { createAction } from "typesafe-actions";
import { ProjectWithCorpora } from "@kol/models/project";

export const Event = {
  load: createAction("/projects/load")<void>(),
};

export const Action = {
  set: createAction("/projects/set")<ProjectWithCorpora[]>(),
};
